<template>
  <div class="">
    <gl-switch
      :value="excludeSameItem"
      @input="$emit('update:excludeSameItem', $event)"
    >
      対象と同じ商品は比較から除外する
    </gl-switch>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

export default {
  mixins: [ErrorReport],
  props: {
    excludeSameItem: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.option-inline {
  display: flex;
}

.option-input {
  width: 60px;
}

.option-field {
  width: 60px;
}

.option-label {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: 16px;
  width: 60px;
}
</style>
